module.exports = {"sessionid":"","group":"","name":"","name_phonetic":"","sex":"","birth_row":"","birth_era":"","birth_year":"","birth_month":"","birth_day":"","photo":"","postal_early":"","postal_last":"","address":"","address_phonetic":"","tel":"","mail":"","postal_early_other":"","postal_last_other":"","address_other":"","address_phonetic_other":"","tel_other":"","mail_other":"","motive":"","commute_hour":"0","commute_minute":"0","dependent":"0","spouse":"","duty":"","wish":"","make_year":"","make_month":"","make_day":""}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/resume/inputs.json
// module id = xSQ6
// module chunks = 0